import styled from "styled-components";

import { Text } from "@/components/Typography";

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    max-width: 380px;
    min-height: 100px;
    max-height: 350px;
    overflow: scroll;
`;

export const DateText = styled(Text)`
    padding: 4px;
    padding-left:24px;
    color: ${props => props.theme.layouts.mainLayout.header.notifications.groupTitleColor};
    border-color: ${props => props.theme.layouts.mainLayout.header.notifications.dividerColor};
    border-top: 2px solid;
    border-bottom: 2px solid;
`;

export const InfoText = styled(Text)`
    min-width: 350px;
    margin-top: auto;
    margin-bottom: auto;
    text-align: center;
`;
